import { createDefaultSummaryData } from '../../ui-toolkit/orders/interfaces/titleReport/ISummary';
import { eTitleEvidenceFeeType } from '../../ui-toolkit/orders/interfaces/titleReport/eTitleEvidenceFeeType';
import { ITitleReportData } from '../../ui-toolkit/orders/interfaces/titleReport/ITitleReport';
import { createDefaultLegalAndVestingData } from '../../ui-toolkit/orders/interfaces/titleReport/ILegalAndVesting';
import { createDefaultBankruptcyData } from '../../ui-toolkit/orders/interfaces/titleReport/IBankruptcy';
import { createDefaultDeedData } from '../../ui-toolkit/orders/interfaces/titleReport/IDeed';
import { createDefaultMortgageData } from '../../ui-toolkit/orders/interfaces/titleReport/IMortgage';
import { createDefaultJudgementInformationData } from '../../ui-toolkit/orders/interfaces/titleReport/IJudgement';

export interface ISearchReportFormData extends Required<ISearchReportFormInitData> {}
export interface ISearchReportFormInitData extends ITitleReportData {
  titleEvidenceFeeType?: eTitleEvidenceFeeType;
}

export const getTitleEvidenceFeeType = (formData?: ISearchReportFormInitData): eTitleEvidenceFeeType =>
  formData && formData.summary && formData.summary.titleEvidencePercent
    ? eTitleEvidenceFeeType.percentage
    : eTitleEvidenceFeeType.fee;

export const getSearchReportForm = (formData?: ISearchReportFormInitData): ISearchReportFormData => {
  const titleEvidenceFeeType =
    formData && formData.summary && formData.titleEvidenceFeeType
      ? formData.titleEvidenceFeeType
      : getTitleEvidenceFeeType(formData);
  return {
    summary: (formData && formData.summary) || createDefaultSummaryData(),
    legalAndVesting: (formData && formData.legalAndVesting) || createDefaultLegalAndVestingData(),
    bankruptcyInformation: (formData && formData.bankruptcyInformation) || createDefaultBankruptcyData(),
    deedInformation: (formData && formData.deedInformation) || [createDefaultDeedData()],
    mortgageInformation: (formData && formData.mortgageInformation) || [createDefaultMortgageData()],
    judgementInformation: (formData && formData.judgementInformation) || createDefaultJudgementInformationData(),
    titleEvidenceFeeType: titleEvidenceFeeType,
  };
};
